export const adminSmallBlockStyle = {
  wrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '16px',
  },
  item: {
    minWidth: 0,
    height: '76px',
    padding: '12px',
    borderRadius: '12px',
    backgroundColor: 'var(--default-white)',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'var(--box-shadow--1)',
  },
  iconBlock: {
    flexShrink: 0,
    background: 'var(--primary-100)',
    borderRadius: '50%',
    padding: '8px',
    mr: '12px',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  topBlock: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    height: '32px',
    minWidth: 0,
  },
  data: {
    fontWeight: '700',
    color: 'var(--neutral-900)',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  changeWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  percents: {
    fontSize: '12px',
    fontWeight: '400',
  },
  name: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    color: 'var(--neutral-300)',
  },
};
